import Api from '../../common/api';

export async function requestGetVariantGroups() {
  const response = await Api.getApi().request('get', '/variant_groups?include_values=true');
  const { data, metadata } = response;
  return { data, metadata };
}

export async function requestPutVariantTagValue(productId, productSkuId, tagValueId) {
  const response = await Api.getApi().request(
    'put',
    `/products/${productId}/skus/${productSkuId}/tag-values/${tagValueId}`,
  );
  const { data, metadata } = response;
  return { data, metadata };
}

export async function requestDeleteVariantTag(productId, productSkuId, tagValueId) {
  const response = await Api.getApi().request(
    'delete',
    `/products/${productId}/skus/${productSkuId}/tag-values/${tagValueId}`,
  );
  const { data, metadata } = response;
  return { data, metadata };
}
